

import Vue from 'vue'

import router from './router'
import App from './App'

import './style/commen.less'
import MyCell from './components/cell.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import btn from './components/button'
Vue.use(DatetimePlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

Vue.component('cell', MyCell)
Vue.component('vux-cell', Cell)
Vue.component('cell-box', CellBox)
Vue.component('group', Group)
Vue.component('popup-picker', PopupPicker)
Vue.component('x-input', XInput)
Vue.component('btn', btn)
Vue.component('popup', Popup)
Vue.component('radio', Radio)





Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js